import Analytic from '@commons/cards/analytic'
import Column from '@components/column'
import Grid from '@components/grid'
import Title from '@components/title'
import React, { Fragment } from 'react'
import PaymentForm from './form'

const PaymentSettings = () => {
  return (
    <Fragment>
      <Column>
        {/* <Grid>
          {Array.from({ length: 4 }).map((_, i) => (
            <Analytic key={i} />
          ))}
        </Grid> */}
        <Title textone="Payment >" texttwo="Settings" />
        <PaymentForm />
      </Column>
    </Fragment>
  )
}

export default PaymentSettings
